import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Select from '@react/react-spectrum/Select'
import Textfield from '@react/react-spectrum/Textfield'

import MediaUpload from 'components/MediaUpload'
import { RichTextFormField } from 'components/RichTextEditor'

const Article = ({ screen, project, projectConfig, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Name'>
        <Textfield
          placeholder='Name'
          name='name'
          value={content.name || ''}
          onChange={onChange('name')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Image' labelFor='image'>
        <MediaUpload
          type='image'
          value={content.image || ''}
          maxHeight='100px'
          onUpload={onChange('image')}
          projectId={project?.meta?.id}
          path={`article-${screen?.meta?.name}-image`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Banner Text Position'>
        <Select
          aria-label='Banner Text Position'
          options={projectConfig.bannerPositionOptions}
          placeholder={'Select an option'}
          name='bannerTextPosition'
          value={content.bannerTextPosition || ''}
          onChange={onChange('bannerTextPosition')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Publication Date'>
        <Textfield
          placeholder='Publication Date'
          name='publicationDate'
          value={content.publicationDate || ''}
          onChange={onChange('publicationDate')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Summary'>
        <RichTextFormField
          label='Page Summary'
          value={content.subtitle || ''}
          onChange={onChange('subtitle')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Description'>
        <RichTextFormField
          label={'Description'}
          value={content.description || ''}
          onChange={onChange('description')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

export default [{ label: 'Article', content: Article }]
